import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function changePassword(formData) {
  const data = await http(`/auth/admin/password`, {
    data: formData,
    method: "PATCH",
  });
  return data;
}

export function useChangePassword() {
  const queryClient = useQueryClient();

  return useMutation(changePassword, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["change-password"]);
    },
  });
}
